import './ErrorComponent.css';
import React from 'react';
import PropTypes from 'prop-types';

const ErrorComponent = ({ message }) => (
  <h3 className="ErrorMessage">{message}</h3>
);

ErrorComponent.displayName = 'ErrorComponent';
ErrorComponent.propTypes = {
  message: PropTypes.string
};
ErrorComponent.defaultProps = {
  message: 'Ocurrió un error'
};

export default ErrorComponent;
